(() => {
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      if (!this.input || !this.results) return;
      this.controller = null;
      this.timer = null;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(this.input.value.trim()), 220);
      });
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.clear();
      });
    }

    clear() {
      this.results.innerHTML = '';
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }

    async search(term) {
      if (this.controller) this.controller.abort();
      if (!term) {
        this.clear();
        return;
      }
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product,collection,article,page,query');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[limit_scope]', 'each');
      try {
        const res = await fetch(url.toString(), { signal: this.controller.signal });
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-predictive-content]');
        this.results.innerHTML = fresh ? fresh.innerHTML : '';
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        if (this.status) {
          const count = this.results.querySelectorAll('[data-predictive-item]').length;
          this.status.textContent = (this.dataset.statusTemplate || '').replace('[count]', count);
        }
      } catch (e) {
        if (e.name !== 'AbortError') this.clear();
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
